import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';



import { GoogleMapScript } from './components/googleMapScript';
import HomePage from './views/homePage';
import ProductsPage from './views/productsPage';
import CategoriesPage from './views/categoriesPage';
import AddProductPage from './views/addProductPage';
import AddCategoryPage from './views/addCategoryPage';
import AddAttributePage from './views/addAttributePage';
import AttributesPage from './views/attributesPage';
import EditProductPage from './views/editProductPage';
import EditCategoryPage from './views/editCategoryPage';
import EditAttributePage from './views/editAttributePage';
import GalleryPage from './views/galleryPage';
import SettingsPage from './views/settingsPage';
import PagesPage from './views/pagesPage';
import AddPagePage from './views/addPagePage';
import EditPagePage from './views/editPagePage';
import LoginPage from './views/loginPage';
import ScraperPage from './views/scraperPage';
import ImportProductPage from './views/importProductPage';
import ContactsPage from './views/contactsPage';

//const history = createHistory();


class Routes extends Component {

    componentDidMount() {
        /*const unlisten = history.listen((location, action) => {
            this.props.handleMenu(null);
        });
        */
    }

    render() {
        return (
            <Router >
                <div>
                    <GoogleMapScript API_KEY="AIzaSyByPzC2VWMbbvAyR3MgBZktkV3gc-nc3rY" />

                    <Switch className="react-switch">
                        <Route
                            path="/"
                            exact
                            render={(...renderProps) => (
                                <HomePage {...renderProps} {...this.props} />
                            )}
                        />


                        <Route
                            path="/products"
                            exact
                            render={(...renderProps) => (
                                <ProductsPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/products/new"
                            exact
                            render={(...renderProps) => (
                                <AddProductPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/products/:pid"
                            exact
                            render={(...renderProps) => (
                                <EditProductPage {...renderProps} {...this.props} />
                            )}
                        />



                        <Route
                            path="/categories"
                            exact
                            render={(...renderProps) => (
                                <CategoriesPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/categories/new"
                            exact
                            render={(...renderProps) => (
                                <AddCategoryPage {...renderProps} {...this.props} />
                            )}
                        />




                        <Route
                            path="/categories/:cid"
                            exact
                            render={(...renderProps) => (
                                <EditCategoryPage {...renderProps} {...this.props} />
                            )}
                        />



                        <Route
                            path="/categories/:cid/scraper"
                            exact
                            render={(...renderProps) => (
                                <ScraperPage {...renderProps} {...this.props} />
                            )}
                        />


                        <Route
                            path="/scraper/import"
                            exact
                            render={(...renderProps) => (
                                <ImportProductPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/categories/:cid/attributes/new"
                            exact
                            render={(...renderProps) => (
                                <AddAttributePage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/categories/:cid/attributes/:aid"
                            exact
                            render={(...renderProps) => (
                                <EditAttributePage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/categories/:cid/attributes"
                            exact
                            render={(...renderProps) => (
                                <AttributesPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/gallery"
                            exact
                            render={(...renderProps) => (
                                <GalleryPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/settings"
                            exact
                            render={(...renderProps) => (
                                <SettingsPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/pages"
                            exact
                            render={(...renderProps) => (
                                <PagesPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/pages/new"
                            exact
                            render={(...renderProps) => (
                                <AddPagePage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/pages/:pid"
                            exact
                            render={(...renderProps) => (
                                <EditPagePage {...renderProps} {...this.props} />
                            )}
                        />


                        <Route
                            path="/login"
                            exact
                            render={(...renderProps) => (
                                <LoginPage {...renderProps} {...this.props} />
                            )}
                        />

                        <Route
                            path="/contacts"
                            exact
                            render={(...renderProps) => (
                                <ContactsPage {...renderProps} {...this.props} />
                            )}
                        />

                    </Switch>
                </div>
            </Router >
        );
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js